import React, { useRef, useState } from "react"
const classNames = require("classnames")

const VolumeOnIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor" stroke="none" />
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
    <path d="M18.07 5.93a9 9 0 0 1 0 12.14" />
  </svg>
)

const VolumeOffIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor" stroke="none" />
    <line x1="23" y1="9" x2="17" y2="15" />
    <line x1="17" y1="9" x2="23" y2="15" />
  </svg>
)

const Cover = ({ className, image, children, video }) => {
  const videoRef = useRef(null)
  const [muted, setMuted] = useState(true)

  const toggleMuted = e => {
    // Cover may be wrapped in a Link, so don't let the click navigate
    e.preventDefault()
    e.stopPropagation()
    const next = !muted
    setMuted(next)
    if (videoRef.current) videoRef.current.muted = next
  }

  if (!image) return null
  return (
    <div
      className={classNames(
        className,
        "relative bg-cover bg-center overflow-hidden"
      )}
      style={{ backgroundImage: `url('${image}')` }}
    >
      <div
        className={classNames(
          "flex flex-col items-center justify-center absolute inset-0 z-20 pt-32 px-8 lg:px-12"
        )}
      >
        {children}
      </div>
      <div className="absolute z-10 inset-0 bg-black bg-opacity-50" />
      {video && (
        <>
          <video
            ref={videoRef}
            className="absolute inset-0 z-0 object-cover object-center h-full w-full bg-black"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={video} type="video/mp4" />
          </video>
          <button
            type="button"
            onClick={toggleMuted}
            aria-label={muted ? "Unmute video" : "Mute video"}
            title={muted ? "Unmute" : "Mute"}
            className="absolute z-30 bottom-4 right-4 flex items-center justify-center h-10 w-10 rounded-full text-white bg-black bg-opacity-40 hover:bg-opacity-70 hover:text-yellow transition-colors"
          >
            {muted ? <VolumeOffIcon /> : <VolumeOnIcon />}
          </button>
        </>
      )}
    </div>
  )
}

export default Cover
